import { Button, Divider, Grid, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Plan } from "@readyfit-common/models";
import useStyles from "./TrainingPlanRow.styles";

interface TrainingPlanRowProps {
  planTemplateWorkout: Plan;
  onSelect: (plan: Plan | null) => void;
  selectedPlanTemplate: Plan | null;
}

const TrainingPlanRow = ({
  planTemplateWorkout,
  onSelect,
  selectedPlanTemplate,
}: TrainingPlanRowProps) => {
  const [selected, setSelected] = useState<boolean>(
    planTemplateWorkout.id === selectedPlanTemplate?.id,
  );
  const classes = useStyles(selected)();

  useEffect(() => {
    setSelected(planTemplateWorkout.id === selectedPlanTemplate?.id);
  }, [selectedPlanTemplate, planTemplateWorkout.id]);

  const handleSelect = () => {
    if (selected) {
      onSelect(null);
      return;
    }
    onSelect(planTemplateWorkout);
  };

  return (
    <Grid
      container
      alignItems={"center"}
      className={classes.container}
      columnGap={1}
    >
      <Grid item xs={2}>
        <img src="/logo.png" alt="logo" className={classes.image} />
      </Grid>
      <Grid item xs={3}>
        <Tooltip title={planTemplateWorkout.name}>
          <Typography variant="h5" className={classes.planName}>
            {planTemplateWorkout.name}
          </Typography>
        </Tooltip>
      </Grid>
      <Grid item sx={{ display: "flex", alignItems: "center", px: 1 }}>
        <Divider orientation="vertical" flexItem />
      </Grid>
      <Grid
        container
        item
        xs={4}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Typography
          variant="subtitle1"
          textTransform={"uppercase"}
          color={"#8F8F8F"}
        >
          Duration
        </Typography>
        <Typography variant="h3">
          {planTemplateWorkout.weekCount} weeks
        </Typography>
      </Grid>
      <Grid item xs={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          onClick={handleSelect}
          variant="outlined"
          className={classes.button}
        >
          {selected ? "Selected" : "Select"}
        </Button>
      </Grid>
    </Grid>
  );
};

export default TrainingPlanRow;
